import { render, staticRenderFns } from "./TheHomeContact.vue?vue&type=template&id=60e7514d&scoped=true"
import script from "./TheHomeContact.vue?vue&type=script&lang=js"
export * from "./TheHomeContact.vue?vue&type=script&lang=js"
import style0 from "./TheHomeContact.vue?vue&type=style&index=0&id=60e7514d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7514d",
  null
  
)

export default component.exports